import React from 'react';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import Footer from '../../components/Shared/Footer';
import HomeHeader from '../Home/Home/HomeHeader/HomeHeader';
import CertificatesArea from './CertificatesArea/CertificatesArea';
import { useTranslation } from "react-i18next";

const Certificates = () => {
    const { t } = useTranslation();
    return (
        <>
            <HomeHeader />
            <CommonPageHeader title={t("certificates")} subtitle="" />
            <CertificatesArea />
            <Footer />
        </>
    );
};

export default Certificates;
